// src/components/Footer.js

import React from "react";
import packageJson from "../../package.json";
import "../styles/modern-layout.css";

function FooterComponent() {
  // Obtener versión desde package.json
  const version = packageJson.version;

  return (
    <div 
      className="footer modern-footer fade-in-tech"
      style={{
        height: "40px",
        display: "flex",
        alignItems: "center",
        padding: "0 20px"
      }}
    >
      <div style={{ 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center",
        width: "100%"
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span className="footer-logo" style={{ fontSize: "14px", color: "white" }}>
            MOGOTAX SAS
          </span>
          <span style={{ fontSize: "12px", opacity: 0.8 }}>
            © {new Date().getFullYear()} Todos los derechos reservados
          </span>
        </div>
        
        <div className="tech-badge" style={{ padding: "2px 10px" }}>
          <span style={{ color: "#00c896", fontWeight: "600", fontSize: "12px" }}>v{version}</span>
        </div>
      </div>
    </div>
  );
}

export default FooterComponent;
